// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","wrapper":"styles_wrapper__P3M4T"};